<template lang="pug">
footer.l-article-footer
  .l-article-footer__kumo1
  .l-article-footer__kumo2
  .l-article-footer__kumo3
  .l-article-footer__inner
    .l-article-footer__info
      dl.l-article-footer__info__dl(
        v-for="info in spot.info"
      )
        dt.l-article-footer__info__dl__dt {{info.title}}
        dd.l-article-footer__info__dl__dd
          div(v-html="info.description")

    ul.l-article-footer__tag
      li.l-article-footer__tag__item(
        v-for="tag in spot.tag"
      ) {{tag}}

    .l-article-footer__nav
      a.l-article-footer__nav__googlemap(v-if="spot.googlemap",:href="spot.googlemap",target="_blank")
        span.l-article-footer__nav__googlemap__txt Google Mapsでみる
        span.l-article-footer__nav__googlemap__ico

      .l-article-footer__nav__share
        span.l-article-footer__nav__share__txt SHARE
        a.l-article-footer__nav__share__ico.facebook(:href="urlFacebook",target="_blank")
        a.l-article-footer__nav__share__ico.twitter(:href="urlTwitter",target="_blank")
        a.l-article-footer__nav__share__ico.line(:href="urlLine",target="_blank")


</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-article-footer
  position relative
  background-color #FFF
  margin-top 90px
  color #404040
  &__kumo1,
  &__kumo2,
  &__kumo3
    background-color #FFF
    
  &__kumo1
    wh(160px,60px)
    pos(-32px,-90px)
    border-radius 30px
  &__kumo2
    wh(280px,60px)
    pos(-32px,-31px)
    border-radius 30px
  &__kumo3
    wh(200px,90px)
    posr(-45px,-70px)
    border-radius 45px

  &__inner
    margin 0 auto
    +pc()
      padding 70px 0px 80px
      width 480px
    +sp()
      padding 70px 0px 80px
      width 600px

  &__info
    color #404040
    &__dl
      &:first-child
        margin-top 0
      +pc()
        margin-top 50px
      +sp()
        margin-top 52px
      &__dt
        display table
        background-color #f2f2f2
        border-radius 10px
        +pc()
          font-size 16px
          padding 0px 15px
        +sp()
          font-size 21px
          padding 0px 15px
      &__dd
        display block
        +pc()
          font-size 22px
          margin-top 5px
          padding-left 8px
        +sp()
          font-size 28px
          margin-top 8px
          padding-left 8px
  
  &__tag
    +pc()
      margin-top 40px
    +sp()
      margin-top 40px
    &__item
      font-weight bold
      display inline-block
      &:before
        content "#"
      
      &:first-child
        margin-left 0
      +pc()
        margin-left 10px
        font-size 21px
      +sp()
        margin-left 10px
        font-size 27px

  &__nav
    clearfix()
    +pc()
      margin-top 80px
    +sp()
      margin-top 100px
    
    &__googlemap
      flexc()
      float left
      +pc()
        wh(218px,48px)
        border-radius 14px
        border 4px solid #e6e6e6
        transition transform 150ms
        &:hover
          transform scale(1.03)
      +sp()
        wh(265px,60px)
        border-radius 14px
        border 4px solid #e6e6e6
      &__txt
        font-weight bold
        +pc()
          font-size 16px
        +sp()
          font-size 21px
      &__ico
        background-image url('~@/assets/images/parts-ico-blank.svg')
        background-size cover
        +pc()
          wh(20px)
          margin-left 10px
        +sp()
          wh(22px)
          margin-left 7px
    
    &__share
      display flex
      justify-content space-between
      align-content center
      align-items center
      float right
      +pc()
        padding-top 5px
      +sp()
        width 270px
        padding-top 5px
      &__txt
        font-weight bold
        +pc()
          font-size 14px
          margin-right 3px
        +sp()
          font-size 18px
          margin-right 3px
      &__ico
        background-size cover
        background-position center
        background-repeat no-repeat
        display block
        +pc()
          wh(40px)
          margin-left 16px
          transition transform 150ms
          &:hover
            transform scale(1.15)
        +sp()
          wh(52px)
          margin-left 16px
        &.facebook
          background-image url('~@/assets/images/parts-ico-facebook.png')
        &.twitter
          background-image url('~@/assets/images/parts-ico-twitter.png')
        &.line
          background-image url('~@/assets/images/parts-ico-line.png')
          +pc()
            display none
</style>


<script>
import { defineComponent, computed, ref, onMounted, reactive } from "vue"
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name:'ArticleFooter',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const spot = computed(()=>{
      return store.api.getSpotById(route.params.id)
    })
    const urlFacebook = computed(()=>{
      const url = encodeURIComponent(location.href)
      return 'https://www.facebook.com/sharer/sharer.php?u=' + url
    })
    const urlTwitter = computed(()=>{
      const url = encodeURIComponent(location.href)
      const txt = encodeURIComponent('【くりからしるべ】' + store.api.getSpotById(route.params.id).name)
      const hashtag = encodeURIComponent('倶利伽羅不動寺,くりからしるべ')
      return 'https://twitter.com/intent/tweet?text='+ txt + '&hashtags=' + hashtag + '&url=' + url
    })
    const urlLine = computed(()=>{
      const url = encodeURIComponent(location.href)
      return 'https://social-plugins.line.me/lineit/share?url=' + url
    })

    return{
      spot,
      urlFacebook,
      urlTwitter,
      urlLine
    }
  }
})
</script>
